/** @format */

// Мы не сможем здесь типизировать все возможные значения, т.к их может быть неизвестное количество
export const getSafeCrName = (name: string): string => {
  switch (name) {
    case 'clicks':
      return 'Клики';
    case 'shows':
      return 'Показы';
    case 'impressions':
      return 'Показы';
    default:
      return name;
  }
};
